import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const CurvedCard = ({className, borderRadius, children}) => {
  const cardClasses = classnames('d-flex flex-column border', className);
  return (
    <div className={cardClasses} style={{borderRadius: borderRadius}}>
      {children}
    </div>
  );
};

CurvedCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  borderRadius: PropTypes.string
};

export default CurvedCard;
